module.exports = __webpack_public_path__ + "img/dummyProfileHeader.51d94f75.png";